import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { DateTime } from 'luxon';
import { Row, Label, TextInput, VerticalSelect } from '../../../common/form/Form';
import { editTemplate } from '../../../../store/data-export/reportTemplatesSlice';

const StyledScheduleReportSelect = styled.div`
  width: 275px;
  position: absolute;
  background: #FFF;
  filter: drop-shadow(1px 1px 8px rgba(0, 0, 0, 0.25));
`;

const ReportSelectForm = styled.div`
  margin: 20px;
`;

const Header = styled.h1`
  width: 100%;
  font-size: 20px;
  text-align: center;
`;

const StyledLabel = styled(Label)`
  font-size: 16px;
`;

export const ScheduleReportSelect = ({ schedule, reportTemplates }) => {
  
  const dispatch = useDispatch();
  
  return (
    <StyledScheduleReportSelect>
      <ReportSelectForm>
        <Row>
          <Header>Report</Header>
        </Row>
        <Row>
          <StyledLabel>Name</StyledLabel>
          <TextInput onChange={(event) => { dispatch(editTemplate({ report_template_id: schedule.resolvedTemplate.report_template_id, title: event.target.value })) }} value={schedule.resolvedTemplate.title}/>
        </Row>
        <Row>
          <StyledLabel>Template</StyledLabel>
          <VerticalSelect selected={0} options={[{ id: 0, text: 'Sysmex Daily' }, { id: 1, text: 'Sysmex Weekly' }, { id: 2, text: 'Sysmex Monthly' }]}/>
        </Row>
      </ReportSelectForm>
    </StyledScheduleReportSelect>
  )
}